import { createClient } from '@supabase/supabase-js'

// ─────────────────────────────────────────────────────────────────────────────
//  SUPABASE SINGLETON
//  Keys come from environment variables — NEVER hard-code them here.
//
//  Create a file called .env in your project root:
//
//    REACT_APP_SUPABASE_URL=https://your-project.supabase.co
//    REACT_APP_SUPABASE_ANON_KEY=your-anon-key
//    REACT_APP_RAZORPAY_KEY_ID=rzp_live_xxxxxxxxxxxxxxxx
//
//  ⚠️  RAZORPAY SECRET KEY must NEVER be in any client file.
//      It belongs only in a server-side Edge Function / backend.
//      Rotate it immediately at: https://dashboard.razorpay.com/app/keys
// ─────────────────────────────────────────────────────────────────────────────

if (!process.env.REACT_APP_SUPABASE_URL || !process.env.REACT_APP_SUPABASE_ANON_KEY) {
  console.error(
    '[GharPe] Missing Supabase env vars.\n' +
    'Add REACT_APP_SUPABASE_URL and REACT_APP_SUPABASE_ANON_KEY to your .env file.'
  )
}

export const supabase = createClient(
  process.env.REACT_APP_SUPABASE_URL      || '',
  process.env.REACT_APP_SUPABASE_ANON_KEY || ''
)
